export default __webpack_public_path__ + "static/media/play-complete.18a8013f.svg";